import { gql, graphql } from "react-apollo"
import type { SlideListViewProps } from "../types"
// import type { OperationComponent } from "react-apollo"

export const GetSlidesQuery = gql`
  query GetAttractLoopSlides($attractLoopId: ID!) {
    attractLoop(id: $attractLoopId) {
      id
      title
      slides {
        id
        title
        headline
        secondary
        mediaURL
        position
      }
    }
  }
`

// type Slide = {
//   id: string,
//   title: string,
//   headline: string,
//   secondary: string,
//   mediaURL: string,
//   position: number
// }

// type AttractLoop = {
//   id: string,
//   title: string,
//   slides: Slide[]
// }

// type Response = {
//   attractLoop: AttractLoop
// }

const options = (props: SlideListViewProps) => ({
  variables: {
    attractLoopId: props.attractLoopId
  }
})

const withAttractLoopSlides = graphql(GetSlidesQuery, {
  options,
  name: "slides",
  props: ({ ownProps, slides: { loading, attractLoop, refetch } }) => ({
    loading,
    slides: attractLoop ? attractLoop.slides : [],
    refetchSlides: refetch
  })
})

export default withAttractLoopSlides



// WEBPACK FOOTER //
// ./src/Slides/queries/withSlides.js